<template>
  <main>
    <section class="char-photos">
      <nuxt-link :to="backLink" class="backlink">{{charName}}</nuxt-link>
      <span> &middot; </span>
      <nuxt-link :to="`${backLink}/cosplay`">Косплей</nuxt-link>
      <h1>Арты персонажа {{ charName }}</h1>
      <button v-if="!getData" @click="getData = !getData" class="dbtn">
        Посмотреть арты
      </button>
      <photos-component v-else :obj="{ text: `аниме персонаж ${charName} арты`, page: 1 }" />

      <div class="desc">
        <div class="poster">
          <img :src="`https://shikimori.one/system/characters/original/${charId}.jpg?1606770681`" :alt="`Аниме персонаж ${charName}`">
        </div>
        <div>
          <p>
            <strong>Арты аниме персонажа {{ charName }}</strong> – это раздел аниме артов (картинок),
            где вы можете посмотреть творчество людей вдохновившихся персонажем {{ charName }}.
          </p>
          <p>
            Не удивляйтесь, если увидите своего любимого персонажа в "не совсем традиционном виде" привычном вам.
            Ведь творчество на то и творчество, чтобы художник мог показать <strong>свое видение героя {{ charName }}</strong>.
          </p>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
export default {
  components: {
    photosComponent: () => import('~/components/photosComponent.vue')
  },
  head() {
    const fullPath = `https://anime777.ru${this.backLink}/art`
    const poster = `https://shikimori.one/system/characters/original/${this.charId}.jpg?1606770681`
    return {
      title: `Арт изображения аниме персонажа ${this.charName}`,
      link: [
        {
          hid: 'canonical',
          rel: 'canonical',
          href: fullPath
        }
      ],
      meta: [
        {
          hid: 'keywords',
          name: 'keywords',
          content: `арт изображения персонажа ${this.charName}`
        },
        {
          hid: 'description',
          name: 'description',
          content: `Лучшие арты аниме персонажа ${this.charName} от талантливых художников.`
        },
        {
          hid: 'og:url',
          property: 'og:url',
          content: fullPath
        },
        {
          hid: 'og:tags',
          property: 'og:tags',
          content: `арт изображения персонажа ${this.charName}`
        },
        {
          hid: 'og:title',
          property: 'og:title',
          content: `Арт изображения аниме персонажа ${this.charName}`
        },
        {
          hid: 'og:description',
          name: 'og:description',
          content: `Лучшие арты аниме персонажа ${this.charName} от талантливых художников.`
        },
        {
          hid: 'og:image',
          property: 'og:image',
          content: poster
        },
        {
          hid: 'twitter:title',
          property: 'twitter:title',
          content: `Арт изображения аниме персонажа ${this.charName}`
        },
        {
          hid: 'twitter:description',
          property: 'twitter:description',
          content: `Лучшие арты аниме персонажа ${this.charName} от талантливых художников.`
        },
        {
          hid: 'twitter:image',
          property: 'twitter:image',
          content: poster
        }
      ]
    }
  },
  async asyncData({ params, route, error, $axios }) {
    const { data } = await $axios.post(`/api/charinfo`, { id: params.id })
    // console.log('data', data)
    if (data.error) return error(data.error)
    const charName = `${data.name} из аниме ${ data.anime[0].name_en }`
    if (!charName) error({ statusCode: 404, message: 'Not Found' })
    return {
      backLink: route.path.replace('/art', ''),
      charId: params.id.slice(0, params.id.indexOf('-')),
      charName,
      getData: false
    }
  }
}
</script>

<style lang="stylus">
.char-photos
  .backlink
    text-transform capitalize
  .desc
    margin-top 40px
    p
      margin 10px 0
  h1
    margin-bottom 40px
    span
      text-transform uppercase
  ul
    list-style none
    display grid
    grid-template-columns repeat(5, 1fr)
    grid-gap 40px 20px
    li
      max-height 140px
      overflow hidden
      transition opacity .2s ease
      &:hover
        opacity .9
      a
        border none
      img
        width 100%
</style>
